import type {
  ExtraFieldType,
  Scalars,
} from "@package/ui-gql/index-data-access";
import type { WritableDraft } from "immer";

export type ServiceDataFormFieldBaseProps = {
  field: ExtraFieldType;
  data?: Scalars["JSONObject"]["output"];
  onSourceChanged: (
    callback: (draft: WritableDraft<Scalars["JSONObject"]["output"]>) => void,
  ) => void;
};

export function ServiceDataFormFieldEmpty() {
  return <div />;
}
